import {coordinate, mapMarker} from "../stepper/stepper-functions";

export default {
    init() {
        $('.dropdown').children('button').on('click', function(e) {
            e.preventDefault();
            if(!$(this).children('.arrow').hasClass('active')) {
                $(this).children('.arrow').addClass('active');
            } else {
                $(this).children('.arrow').removeClass('active');
            }
        });

        $('#showMainMenu').on('click', function(e) {
            e.preventDefault();
            $(this).toggleClass('is-active');
            $('.find-button-mobile').toggleClass('d-block');
            $('.find-button-mobile').toggleClass('d-none');
        });

        $('.custom-checkbox').on('click', function (e) {
            e.preventDefault();
            customChecked($(this));
        });

        $('.form-check-label').on('click', function () {
            customChecked($(this).parent('.form-check').children('.custom-checkbox'));
        });

        function customChecked($this) {
            if(!$this.hasClass('checked')) {
                $this.addClass('checked');
                $this.parent('.form-check').children('input[type="checkbox"]').prop('checked', true).trigger('change');
            } else {
                $this.removeClass('checked');
                $this.parent('.form-check').children('input[type="checkbox"]').prop('checked', false).trigger('change');
            }
        }

        $('.post-code-form-search').on('submit', function (e) {
            e.preventDefault();
            let $this = $(this);
            let postCode = $(this).find('input[name="post_code"]').val();
            let action =  $(this).attr('action');
            if(postCode !== '') {
                let geocoder = new google.maps.Geocoder();
                geocoder.geocode({ 'address': postCode }, function (results, status) {
                    if (status === google.maps.GeocoderStatus.OK) {
                        window.location = action + '/?post_code=' + postCode;
                    } else {
                        $this.children('.post-code__form--input, .find-broker__form--input').addClass('error');
                    }
                });
            } else {
                $this.children('.post-code__form--input, .find-broker__form--input').addClass('error');
            }
        });

        $('.post-code-form-search').find('input[name="post_code"]').on('focus', function () {
            $(this).parent('.post-code__form--input, .find-broker__form--input').removeClass('error');
        });

        if($('.header-broker-sign-up').length >= 1) {
            $(window).scroll(function() {
                let $headerBrokerSignUp = $('.header-broker-sign-up');
                let scroll_offset = $headerBrokerSignUp.offset().top;
                ( scroll_offset > 20 ) ? $headerBrokerSignUp.addClass('header-scroll') : $headerBrokerSignUp.removeClass('header-scroll');
            });
        }

        jQuery(document).on('click', '.wp-block-button a', function (e) {
            e.preventDefault();
            let id = '#' + $(this).attr('rel');
            let headerHeight = $('.header').outerHeight();
            if($(id).length > 0) {
                let top = $(id).offset().top - headerHeight;
                $('body, html').animate({ scrollTop: top }, 1000);
            }
        });

        jQuery(document).on('click', '.package', function (e) {
            e.preventDefault();
            $('.package').removeClass('active');
            $(this).children('input[type="radio"]').prop('checked', true);
            if(!$(this).hasClass('active')) {
                $(this).addClass('active');
            } else {
                $(this).removeClass('active');
            }
        });

        $('.contact-us-template').find('.wpcf7-form').find('input[name="your-name"]').keypress(function(event) {
            return /[а-яА-ЯёЁa-zA-Z /s]/i.test(event.key);
        });

        if(window.location.hash) {
            let hash = window.location.hash;
            $(hash).modal('toggle');
        }
    },
    finalize() {

    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js